export function getAccessToken(): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  return localStorage.getItem("superbar_access_token");
}

export function getImpersonatedRole(): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  return localStorage.getItem("superbar_impersonation");
}

export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const token = getAccessToken();
  const impersonatedRole = getImpersonatedRole();
  const headers = new Headers(init?.headers);

  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (impersonatedRole && !headers.has("x-superbar-impersonate-role")) {
    headers.set("x-superbar-impersonate-role", impersonatedRole);
  }

  const response = await fetch(input, {
    ...init,
    headers,
  });

  if (response.status === 401 && typeof window !== "undefined") {
    localStorage.removeItem("superbar_access_token");
    localStorage.removeItem("superbar_refresh_token");
    localStorage.removeItem("superbar_user");
    localStorage.removeItem("superbar_impersonation");
    window.location.href = "/login";
  }

  return response;
}

export const authenticatedApiFetch = apiFetch;
